import * as THREE from '@phdsoft/three';
import { ShapeType } from './geometry-extrusion.types';
import { Util } from '@phdsoft/common';

export class GeometryExtrusionComputer {
  static isDisplacementNull: any=true;
  static isFirstPointTheMajorWebHeight: any;
  static displacement: number=0;
  static webUpVector: THREE.Vector3;
  static webBaseVector: THREE.Vector3;

    public static computeStiffener(elementGeometry: THREE.Mesh, line: THREE.Vector3[], plates:THREE.Mesh[],  webHeight: number, flangeWidth: number, 
        stiffenerFormatName: ShapeType, onFrontSide: boolean, invertFlange:boolean, sectionNormal:THREE.Vector3, normal:THREE.Vector3): 
        {webPoints: number[], webIndices: number[], flangePoints: number[], flangeIndices: number[]} {
        try {
            // this.setPrimitive3DNull();
            let webPointCoordinates: number[] | null = null;
            let webTriangleIndices: number[] | null = null;
            let topFlangePointCoordinates: number[] | null = null;
            let topFlangeTriangleIndices: number[] | null = null;
            let bottomFlangePointCoordinates: number[] | null = null;
            let bottomFlangeTriangleIndices: number[] | null = null;
        
            let webPoints: THREE.Vector3[] = [];
            let webIndices: number[] = [];
            let bottomFlangePoints: THREE.Vector3[] = [];
            let bottomFlangeIndices: number[] = [];
            let topFlangePoints: THREE.Vector3[] = [];
            let topFlangeIndices: number[] = [];
            let flangeAxisPoints: THREE.Vector3[] = [];
            let webAxisPoints: THREE.Vector3[] = [];
        
            let flangeAxis3D:any;
            {
            //   const geometricPrimitive = this.primitive(index);
        
            //   // Check if it is a Polyline
            //   if (!(geometricPrimitive instanceof Polyline)) {
            //     return;
            //   }
        
            //   // Check if web height is valid
            //   if (this.isWebHeightNull || this.webHeight < 0.01) {
            //     return;
            //   }
        
              // Clear arrays for this iteration
              webPoints = [];
              webIndices = [];
              bottomFlangePoints = [];
              bottomFlangeIndices = [];
              topFlangePoints = [];
              topFlangeIndices = [];
              flangeAxisPoints = [];
              webAxisPoints = [];
        
              // Check flange
              const isFlangeWidthValid = (
                // !this.isFlangeWidthNull &&
                flangeWidth > 0.01 
                // &&
                // !this.isStiffenerFormatNameNull
              );
        
            //   const polyline = geometricPrimitive as Polyline;
            //   polyline.reorderPointsAlongBestLine();
              // -----------------
              // CREATE THE WEB
              // -----------------
              let normals = GeometryExtrusionComputer.AdjustNormals(line, sectionNormal);
              for (let i = 0; i < line.length; i++) {
                // We assume getPoint(i) returns a Point3D
                let p1 = line[i].clone();
                let p2 = p1.clone(); // copy of p1
        
                if (i === 0 || i === line.length - 1) {
                  // // first or last point
                  // let normal = (i === 0)
                  //   ? this.getFaceNormalAtPoint(elementGeometry, p1.clone(), plates, sectionNormal.clone())??this.getFaceNormalAtPoint(elementGeometry, p1.clone()  , plates, sectionNormal.clone().multiplyScalar(-1))// polyline.getNormal(i)
                  //   : this.getFaceNormalAtPoint(elementGeometry, line[i-1].clone(), plates, sectionNormal.clone())??this.getFaceNormalAtPoint(elementGeometry, line[i-1].clone(), plates, sectionNormal.clone().multiplyScalar(-1))//polyline.getNormal(i - 1);
                  // // let normal = new THREE.Vector3(1,0,0);

                  let normal = i === 0 ? normals[i].clone() : normals[i-1].clone();

                  if(!normal){
                    for (const plate of plates) {
                      if (this.boxesDistance(plate.geometry.boundingBox, elementGeometry.geometry.boundingBox) <= 0.5) {// &&
                        // if (plate.geometry.boundingBox.intersectsBox(stiffener.geometry.boundingBox)) {
                        normal = this.checkTriangleCollision(plate, elementGeometry, 0.021);
                        if(normal !== null){
                          
                          break
                        }
                      }
                    }
                  }
                  normal = normal.normalize();
                  if (!onFrontSide) {
                    // In C#,  normal = -1 * normal
                    normal =normal.multiplyScalar(-1);
                  }
        
                  p1 = line[i].clone();
                  p2 = p1.clone().addScaledVector(normal, webHeight);//this.addVector(p1, normal, webHeight);
                } else {
                  // inner points
                  const pointA = line[i-1].clone();//polyline.getPoint(i - 1);
                  const pointB = line[i].clone();// polyline.getPoint(i);
                  const pointC = line[i+1].clone();// polyline.getPoint(i + 1);
        
                  let normalAB = normals[i-1].clone()//this.getFaceNormalAtPoint(elementGeometry, pointA.clone(), plates, sectionNormal)//polyline.getNormal(i - 1);
                  let normalBC = normals[i].clone()//??this.getFaceNormalAtPoint(elementGeometry, pointB.clone(), plates, sectionNormal);//polyline.getNormal(i);
        
                  // if(!normalAB){
                  //   for (const plate of plates) {
                  //     if (this.boxesDistance(plate.geometry.boundingBox, elementGeometry.geometry.boundingBox) <= 0.5) {// &&
                  //       // if (plate.geometry.boundingBox.intersectsBox(stiffener.geometry.boundingBox)) {
                  //       normalAB = this.checkPointTriangleCollision(plate, pointA.clone(), 0.021);
                  //       if(normalAB !== null){
                  //         normalAB.normalize();
                  //         break
                  //       }
                  //     }
                  //   }
                  // }
                  // normalAB = normalAB.normalize();
                  // if(!normalBC){
                  //   for (const plate of plates) {
                  //     if (this.boxesDistance(plate.geometry.boundingBox, elementGeometry.geometry.boundingBox) <= 0.5) {// &&
                  //       normalBC = this.checkPointTriangleCollision(plate, pointB.clone(), 0.021);
                  //       if(normalBC !== null){
                  //         normalBC.normalize();
                  //         break
                  //       }
                  //     }
                  //   }
                  // }
                  // normalBC = normalBC.normalize();
                  if (!onFrontSide) {
                    normalAB = normalAB.clone().multiplyScalar(-1);//this.negateVector(normalAB);
                    normalBC = normalBC.clone().multiplyScalar(-1);//this.negateVector(normalBC);
                  }
        
                  const v = normalAB.clone().multiplyScalar(webHeight);//this.scaleVector(normalAB, this.webHeight);
                  const u = normalBC.clone().multiplyScalar(webHeight);//this.scaleVector(normalBC, this.webHeight);
        
                  // t = 0.5 * (u + v)
                  const t = (u.clone().add(v.clone())).multiplyScalar(0.5);//this.scaleVector(this.addVectors(u, v), 0.5);
                  // w = 0.5 * (u - v)
                  const w = (u.clone().sub(v.clone())).multiplyScalar(0.5);//this.scaleVector(this.subtractVectors(u, v), 0.5);
        
                  const lengthT = t.clone().normalize().length();//this.normalizeVector(t);
                  const lengthW = w.clone().normalize().length();//this.normalizeVector(w);
        
                  const l = (lengthW * lengthW) / lengthT;
        
                  p1 = pointB.clone();
                  // p2 = pointB + (l + lengthT) * t

                  let sumlT = l + lengthT;
                  let product = t.clone().multiplyScalar(sumlT);
                  p2 = pointB.clone().add(product);//this.addVector(pointB, t, (l + lengthT));
                }
        
                webPoints.push(p1);
                webPoints.push(p2);
        
                // webAxisPoints.Add(0.5 * (p1 + p2));
                webAxisPoints.push(this.midpoint(p1, p2));
        
                if (!isFlangeWidthValid) {
                  // flangeAxisPoints.Add(p2);
                  //flangeAxisPoints.push(p2);
                }
              }
        
              // Indices for web
              for (let i = 0; i < line.length - 1; i++) {
                // Each "Add" in C# becomes a .push(...) in JS/TS
                webIndices.push(i * 2 + 1, i * 2 + 0, i * 2 + 2);
                webIndices.push(i * 2 + 1, i * 2 + 2, i * 2 + 3);
              }
        
              // Prepare the web mesh
              webPointCoordinates = new Array(webPoints.length * 3);
              for (let i = 0; i < webPoints.length; i++) {
                webPointCoordinates[i * 3 + 0] = webPoints[i].x;
                webPointCoordinates[i * 3 + 1] = webPoints[i].y;
                webPointCoordinates[i * 3 + 2] = webPoints[i].z;
              }
        
              webTriangleIndices = [...webIndices]; // copy array
        
            //   const webMesh = new IrregularMesh(webPointCoordinates, webTriangleIndices);
            //   webMesh.equalizeNormalDirections();
        
            //   // In C#, base.DrawingPrimitives3D.Add(webMesh);
            //   // Adjust to your own references in TS (this.drawingPrimitives3D, etc.)
            //   this.drawingPrimitives3D.push(webMesh);
            //   this.webDrawingPrimitives3D.push(webMesh);
            //   this.webAxis3D.push(new Polyline(/* pass in webAxisPoints if your TS Polyline can take that */));
        
              if (!isFlangeWidthValid) {
                //flangeAxis3D.push( ...flangeAxisPoints);
              }
        
              // ------------------------
              // CREATE THE FLANGE
              // ------------------------
              if (isFlangeWidthValid) {
                for (let i = 0; i < line.length; i++) {
                  let pQ: THREE.Vector3 = line[i].clone();
                  let pR: THREE.Vector3 = pQ.clone();
        
                  if (i === 0 || i === line.length - 1) {
                    // first or last point
                    let pointB:THREE.Vector3 = new THREE.Vector3();
                    let normal: THREE.Vector3 = null
                    let webDirection: THREE.Vector3 = null;
        
                    if (i === 0) {
                      const p1 = webPoints[i * 2 + 1];
                      const p2 = webPoints[i * 2 + 3];
                      pointB = p1;
                      // normal = normal = new THREE.Vector3(1,0,0);//this.getFaceNormalAtPoint(line[i], plates, sectionNormal) //polyline.getNormal(i);

                      normal = normals[i].clone()//this.getFaceNormalAtPoint(elementGeometry, p1, plates, sectionNormal.clone())??this.getFaceNormalAtPoint(elementGeometry, p1, plates, sectionNormal.clone().multiplyScalar(-1))

                      if(!normal){
                        let value = Util.LargestCanonicalAxisValue(sectionNormal);
                        let sectionNormalLocal = new THREE.Vector3(value[0], value[1], value[2]); 
                        normal = normals[i].clone()//this.getFaceNormalAtPoint(elementGeometry, p1, plates, sectionNormalLocal.clone())??this.getFaceNormalAtPoint(elementGeometry, p1, plates, sectionNormalLocal.clone().multiplyScalar(-1))

                      }
                      // ? this.getFaceNormalAtPoint(p1, plates, sectionNormal)??this.getFaceNormalAtPoint(p1, plates, sectionNormal.multiplyScalar(-1))// polyline.getNormal(i)
                      // : this.getFaceNormalAtPoint(line[i-1], plates, sectionNormal)//polyline.getNormal(i - 1);
                      webDirection = p2.clone().sub(p1).normalize(); // this.subtractVectors(p2, p1);
                    //   this.normalizeVector(webDirection);
                    } else {
                      const p1 = webPoints[(i - 1) * 2 + 1];
                      const p2 = webPoints[(i - 1) * 2 + 3];
                      pointB = p2.clone();
                    //   normal = polyline.getNormal(i - 1);
                    //   webDirection = this.subtractVectors(p2, p1);
                    //   this.normalizeVector(webDirection);

                      normal = normals[i-1].clone()//this.getFaceNormalAtPoint(elementGeometry, p1, plates, sectionNormal.clone())??this.getFaceNormalAtPoint(elementGeometry, p1, plates, sectionNormal.clone().multiplyScalar(-1));//new THREE.Vector3(1,0,0);//this.getFaceNormalAtPoint(line[i-1], plates, sectionNormal) //polyline.getNormal(i);
                      webDirection = p2.clone().sub(p1.clone()).normalize(); // this.subtractVectors(p2, p1);
                    //   this.normalizeVector(webDirection);
                    }
        
                    if (!onFrontSide) {
                      normal = normal.multiplyScalar(-1.0); // this.negateVector(normal);
                    }
        
                    const flangeDirection = webDirection.clone().cross(normal.clone()).normalize(); // this.crossVectors(webDirection, normal);
                    // this.normalizeVector(flangeDirection);
        
                    switch (stiffenerFormatName) {
                      case "Stiffener_T_Build":
                      // case "'T' Built":
                        pQ = pointB.clone().addScaledVector(flangeDirection, -0.5 * flangeWidth); //this.addVector(pointB, flangeDirection, -0.5 * this.flangeWidth);
                        pR = pointB.clone().addScaledVector(flangeDirection, 0.5 * flangeWidth);//this.addVector(pointB, flangeDirection, +0.5 * this.flangeWidth);
                        break;
        
                      case "Stiffener_L_Build":
                      // case "'L' Built":
                        switch (invertFlange) {
                          case true:
                            pQ = pointB.clone().addScaledVector(flangeDirection, -1 * flangeWidth);//this.addVector(pointB, flangeDirection, -1.0 * this.flangeWidth);
                            pR = pointB.clone(); // i.e., no shift
                            break;
                          case false:
                            pQ = pointB.clone();
                            pR = pointB.clone().addScaledVector(flangeDirection, 1 * flangeWidth);;//this.addVector(pointB, flangeDirection, +1.0 * this.flangeWidth);
                            break;
                        }
                        break;
        
                      // case "'I' Laminate":
                      // case "'I' Built":
                      //   pQ = pointB.addScaledVector(flangeDirection, -0.5 * flangeWidth);//this.addVector(pointB, flangeDirection, -0.5 * this.flangeWidth);
                      //   pR = pointB.addScaledVector(flangeDirection, 0.5 * flangeWidth);//this.addVector(pointB, flangeDirection, +0.5 * this.flangeWidth);
        
                      //   // Also create bottom flange for 'I'
                      //   const pointO = polyline.getPoint(i);
                      //   bottomFlangePoints.push(
                      //     this.addVector(pointO, flangeDirection, -0.5 * this.flangeWidth, normal, 0.01)
                      //   );
                      //   bottomFlangePoints.push(
                      //     this.addVector(pointO, flangeDirection, +0.5 * this.flangeWidth, normal, 0.01)
                      //   );
                      //   break;
                    }
        
                    topFlangePoints.push(pQ, pR);
                  } else {
                    // inner points
                    const pointO = webPoints[i * 2]; // for 'I' case
                    const pointA = webPoints[i * 2 - 1];
                    const pointB = webPoints[i * 2 + 1];
                    const pointC = webPoints[i * 2 + 3];
        
                    let normalAB = normals[i-1].clone()//this.getFaceNormalAtPoint(elementGeometry, pointA.clone(), plates, sectionNormal)//polyline.getNormal(i - 1);
                    let normalBC = normals[i].clone()//this.getFaceNormalAtPoint(elementGeometry, pointB.clone(), plates, sectionNormal);//polyline.getNormal(i);
          
                    if(!normalAB){
                      for (const plate of plates) {
                        if (this.boxesDistance(plate.geometry.boundingBox, elementGeometry.geometry.boundingBox) <= 0.5) {// &&
                          // if (plate.geometry.boundingBox.intersectsBox(stiffener.geometry.boundingBox)) {
                          normalAB = this.checkPointTriangleCollision(plate, pointA.clone(), 0.021);
                          if(normalAB !== null){
                            normalAB.normalize();
                            break
                          }
                        }
                      }
                    }
  
                    if(!normalBC){
                      for (const plate of plates) {
                        if (this.boxesDistance(plate.geometry.boundingBox, elementGeometry.geometry.boundingBox) <= 0.5) {// &&
                          normalBC = this.checkPointTriangleCollision(plate, pointB.clone(), 0.021);
                          if(normalBC !== null){
                            normalBC.normalize();
                            break
                          }
                        }
                      }
                    }
                    normalAB = normalAB.normalize();
                    normalBC = normalBC.normalize();
                    if (!onFrontSide) {
                      normalAB = normalAB.multiplyScalar(-1.0); // this.negateVector(normalAB);
                      normalBC = normalBC.multiplyScalar(-1.0);//this.negateVector(normalBC);
                    }
        
                    const webDirectionAB = pointB.clone().sub(pointA.clone()).normalize()// this.subtractVectors(pointB, pointA);
                    // this.normalizeVector(webDirectionAB);
                    const flangeDirectionAB = webDirectionAB.clone().cross(normalAB.clone()).normalize(); //this.crossVectors(webDirectionAB, normalAB);
                    // this.normalizeVector(flangeDirectionAB);
        
                    const webDirectionBC = pointC.clone().sub(pointB.clone()).normalize(); //this.subtractVectors(pointC, pointB);
                    // this.normalizeVector(webDirectionBC);
                    const flangeDirectionBC = webDirectionBC.clone().cross(normalBC.clone()).normalize(); //this.crossVectors(webDirectionBC, normalBC);
                    // this.normalizeVector(flangeDirectionBC);
                            
                    // inner points
                    const v = flangeDirectionAB.clone().multiplyScalar(flangeWidth);
                    const u = flangeDirectionBC.clone().multiplyScalar(flangeWidth);

                    // ½(u + v) and ½(u – v)
                    const t = u.clone().add(v).multiplyScalar(0.5);
                    const w = u.clone().sub(v).multiplyScalar(0.5);

                    // lengths BEFORE normalization
                    const lengthT = t.length();
                    const lengthW = w.length();

                    // miter‐extension: L = (w² / t) + t
                    const L = (lengthW * lengthW) / lengthT + lengthT;

                    // normalized bisector
                    const tNorm = t.clone().divideScalar(lengthT);

                    // half‐length along bisector
                    const half = L * 0.5;
        
                    switch (stiffenerFormatName) {
                      case "Stiffener_T_Build":
                      // case "'T' Built":

                        pQ = pointB.clone().addScaledVector(tNorm, -half);
                        pR = pointB.clone().addScaledVector(tNorm,  half);
                        break;
        
                      case "Stiffener_L_Build":
                      // case "'L' Built":
                        switch (invertFlange) {
                          case true:
                            pQ = pointB.clone().addScaledVector(t, -1.0 * L); //this.addVector(pointB, t, -1.0 * l);
                            pR = pointB.clone();
                            break;
                          case false:
                            pQ = pointB.clone();
                            pR = pointB.clone().addScaledVector(tNorm, L); //this.addVector(pointB, t, +1.0 * l);
                            break;
                        }
                        break;
        
                      // case "'I' Laminate":
                      // case "'I' Built":
                      //   pQ = this.addVector(pointB, t, -0.5 * l);
                      //   pR = this.addVector(pointB, t, +0.5 * l);
        
                      //   // bottomFlangePoints...
                      //   bottomFlangePoints.push(
                      //     this.addVector(pointO, t, -0.5 * l, normalAB, 0.01)
                      //   );
                      //   bottomFlangePoints.push(
                      //     this.addVector(pointO, t, +0.5 * l, normalAB, 0.01)
                      //   );
                      //   break;
                    }
        
                    topFlangePoints.push(pQ, pR);
                  }
        
                  // flangeAxisPoints.Add(0.5 * (pQ + pR));
                  //flangeAxisPoints.push(this.midpoint(pQ, pR));
                }
        
                // Build top flange mesh if we have points
                if (topFlangePoints.length > 0) {
                  for (let i = 0; i < line.length - 1; i++) {
                    topFlangeIndices.push(i * 2 + 0, i * 2 + 1, i * 2 + 3);
                    topFlangeIndices.push(i * 2 + 0, i * 2 + 3, i * 2 + 2);
                  }
        
                  topFlangePointCoordinates = new Array(topFlangePoints.length * 3);
                  for (let i = 0; i < topFlangePoints.length; i++) {
                    topFlangePointCoordinates[i * 3 + 0] = topFlangePoints[i].x;
                    topFlangePointCoordinates[i * 3 + 1] = topFlangePoints[i].y;
                    topFlangePointCoordinates[i * 3 + 2] = topFlangePoints[i].z;
                  }
        
                  topFlangeTriangleIndices = [...topFlangeIndices];
        
                  // const topFlangeMesh = new IrregularMesh(topFlangePointCoordinates, topFlangeTriangleIndices);
                  // topFlangeMesh.equalizeNormalDirections();
        
                  // this.drawingPrimitives3D.push(topFlangeMesh);
                  // this.flangeDrawingPrimitives3D.push(topFlangeMesh);
                  // this.flangeAxis3D.push(new Polyline(/* pass flangeAxisPoints */));
                }
        
                // Build bottom flange mesh if we have points
                if (bottomFlangePoints.length > 0) {
                  for (let i = 0; i < line.length - 1; i++) {
                    bottomFlangeIndices.push(i * 2 + 0, i * 2 + 1, i * 2 + 3);
                    bottomFlangeIndices.push(i * 2 + 0, i * 2 + 3, i * 2 + 2);
                  }
        
                  bottomFlangePointCoordinates = new Array(bottomFlangePoints.length * 3);
                  for (let i = 0; i < bottomFlangePoints.length; i++) {
                    bottomFlangePointCoordinates[i * 3 + 0] = bottomFlangePoints[i].x;
                    bottomFlangePointCoordinates[i * 3 + 1] = bottomFlangePoints[i].y;
                    bottomFlangePointCoordinates[i * 3 + 2] = bottomFlangePoints[i].z;
                  }
        
                  bottomFlangeTriangleIndices = [...bottomFlangeIndices];
        
                  // const bottomFlangeMesh = new IrregularMesh(bottomFlangePointCoordinates, bottomFlangeTriangleIndices);
                  // bottomFlangeMesh.equalizeNormalDirections();
        
                  // this.drawingPrimitives3D.push(bottomFlangeMesh);
                  // this.flangeDrawingPrimitives3D.push(bottomFlangeMesh);
                }
              } // end if (isFlangeWidthValid)
            } // end for (index = 0; ...)

            return {webPoints: webPointCoordinates, webIndices: webTriangleIndices, flangePoints: topFlangePointCoordinates, flangeIndices: topFlangeTriangleIndices};
          } catch (ex) {
            throw new Error("The primitive cannot be obtained: " + (ex as Error).message);
          }
        return null;
    }

    public static computeBracket(elementGeometry:THREE.Mesh, line: THREE.Vector3[], plates:THREE.Mesh[], stiffeners:THREE.Mesh[],  webHeight: number, flangeWidth: number, w2: number, w1: number,
      nose: number, majorWebWidth: number,
      stiffenerFormatName: ShapeType, onFrontSide: boolean, invertFlange:boolean, sectionNormal:THREE.Vector3, InvertBracket:boolean): 
      {webPoints: number[], webIndices: number[], flangePoints: number[], flangeIndices: number[]} 
    {
      try {
        let webPointCoordinates: number[] | null = null;
        let webTriangleIndices: number[] | null = null;
        let flangePointCoordinates: number[] | null = null;
        let flangeTriangleIndices: number[] | null = null;
    
        const webPoints: THREE.Vector3[] = [];
        const webIndices: number[] = [];
        const flangePoints: THREE.Vector3[] = [];
        const flangeIndices: number[] = [];
        const flangeAxisPoints: THREE.Vector3[] = [];
        const webAxisPoints: THREE.Vector3[] = [];
    
        const isMajorWebHeightValid = w2 > 0.01;
        const isMinorWebHeightValid = w1 > 0.01;
        const isMinorWebWidthValid = nose > 0.01;
        const isFlangeWidthValid = majorWebWidth > 0.01;
    
        if (!isMajorWebHeightValid && !isMinorWebHeightValid) {
          return;
        }
        var result = this.findNeighborStiffener(line, stiffeners, sectionNormal.clone(), onFrontSide);
        
        let normal = this.getFaceNormalAtPoint(elementGeometry, line[0], plates, sectionNormal.clone())??this.getFaceNormalAtPoint(elementGeometry, line[0], plates, sectionNormal.clone().multiplyScalar(-1));//new THREE.Vector3(1,0,0);//polyline.normal.clone();
        normal.normalize();
        if (!onFrontSide) {
          normal = normal.multiplyScalar(-1);
        }
    
        let firstPoint = line[0].clone();
        let lastPoint = line[line.length - 1].clone();//polyline.getPoint(polyline.count - 1);
    
        if (!this.isFirstPointTheMajorWebHeight) {
          lastPoint = line[0].clone();
          firstPoint = line[line.length - 1].clone();
        }
        if (InvertBracket) {
          let temp = firstPoint.clone();
          firstPoint = lastPoint.clone();
          lastPoint = temp.clone();
        }
        if (!this.isDisplacementNull) {
          firstPoint = firstPoint.add(normal.clone().multiplyScalar(this.displacement));
          lastPoint = lastPoint.add(normal.clone().multiplyScalar(this.displacement));
        }    
        const webWidthDirection = lastPoint.clone().sub(firstPoint).normalize();
        const flangeWidthDirection = webWidthDirection.clone().cross(normal).normalize();
    
        this.webUpVector = normal.clone().normalize();
    
        if (isMajorWebHeightValid && isMinorWebHeightValid && isMinorWebWidthValid) {
          // Trapecio with flange
          this.webBaseVector = lastPoint.clone().sub(firstPoint).normalize();
    
          webPoints.push(firstPoint);
          webPoints.push(lastPoint);
          webPoints.push(lastPoint.clone().add(normal.clone().multiplyScalar(w1)));
          webPoints.push(
            firstPoint
              .clone()
              .add(normal.clone().multiplyScalar(w2))
              .add(webWidthDirection.clone().multiplyScalar(nose))
          );
          webPoints.push(firstPoint.clone().add(normal.clone().multiplyScalar(w2)));
    
          webIndices.push(0, 1, 2, 0, 2, 3, 0, 3, 4);
    
          webAxisPoints.push(
            firstPoint.clone().add(lastPoint).multiplyScalar(0.5),
            firstPoint
              .clone()
              .add(normal.clone().multiplyScalar(0.5 * w2))
              .add(webWidthDirection.clone().multiplyScalar(nose)),
            firstPoint.clone().add(webPoints[4]).multiplyScalar(0.5)
          );
    
          if (isFlangeWidthValid) {
            this.generateFlange(webPoints, flangePoints, flangeIndices, flangeAxisPoints, flangeWidthDirection, "trapecio-major-minor", invertFlange, majorWebWidth);
          }
        }
        // Handle other conditions (e.g., other combinations of web height/width validity)
        else if (isMajorWebHeightValid && isMinorWebHeightValid) {
          // Trapecio without minorWebWidth
          this.webBaseVector = lastPoint.clone().sub(firstPoint).normalize();
    
          webPoints.push(firstPoint);
          webPoints.push(lastPoint);
          webPoints.push(lastPoint.clone().add(normal.clone().multiplyScalar(w1)));
          webPoints.push(firstPoint.clone().add(normal.clone().multiplyScalar(w2)));
    
          webIndices.push(0, 1, 2, 0, 2, 3);
    
          webAxisPoints.push(
            lastPoint.clone().add(webPoints[2]).multiplyScalar(0.5),
            firstPoint.clone().add(webPoints[3]).multiplyScalar(0.5)
          );
    
          if (isFlangeWidthValid) {
            this.generateFlange(webPoints, flangePoints, flangeIndices, flangeAxisPoints, flangeWidthDirection, "trapecio-major-minor", invertFlange, majorWebWidth);
          }
        }
        // Add other conditions here...
    
        // Convert web points and indices to coordinate arrays
        webPointCoordinates = new Array(webPoints.length * 3);
        for (let i = 0; i < webPoints.length; i++) {
          webPointCoordinates[i * 3 + 0] = webPoints[i].x;
          webPointCoordinates[i * 3 + 1] = webPoints[i].y;
          webPointCoordinates[i * 3 + 2] = webPoints[i].z;
        }
    
        webTriangleIndices = [...webIndices];
    
        // const webMesh = new IrregularMesh(webPointCoordinates, webTriangleIndices);
        // webMesh.equalizeNormalDirections();
    
        // this.drawingPrimitives3D.push(webMesh);
        // this.webDrawingPrimitive3D = webMesh;
        // this.webAxis3D = new Polyline(webAxisPoints);
    
        if (isFlangeWidthValid) {
          flangePointCoordinates = new Array(flangePoints.length * 3);
          for (let i = 0; i < flangePoints.length; i++) {
            flangePointCoordinates[i * 3 + 0] = flangePoints[i].x;
            flangePointCoordinates[i * 3 + 1] = flangePoints[i].y;
            flangePointCoordinates[i * 3 + 2] = flangePoints[i].z;
          }
    
          flangeTriangleIndices = [...flangeIndices];
    
          // const flangeMesh = new IrregularMesh(flangePointCoordinates, flangeTriangleIndices);
          // flangeMesh.equalizeNormalDirections();
    
          // this.drawingPrimitives3D.push(flangeMesh);
          // this.flangeDrawingPrimitive3D = flangeMesh;
          // this.flangeAxis3D = new Polyline(flangeAxisPoints);
        }
        return {webPoints: webPointCoordinates, webIndices: webTriangleIndices, flangePoints: flangePointCoordinates, flangeIndices: flangeTriangleIndices};

      } catch (ex) {
        throw new Error(`The primitive cannot be obtained: ${(ex as Error).message}`);
      }
  }
  static findNeighborStiffener(line: THREE.Vector3[],
     stiffeners: THREE.Mesh[],
      sectionNormal:THREE.Vector3, onFrontSide: boolean) : any{
    let result = this.findConcurrentStiffener(stiffeners, line[0], line[line.length-1]);
    if(result){

      let onFrontSideStiffener = this.isStiffenerOnPositiveSide(result, line[0], sectionNormal);
      if(onFrontSide === onFrontSideStiffener){
        const height = this.getStiffenerHeight(result, sectionNormal);
        console.log("Max stiffener height along the section normal:", height);
        if(height){
          this.displacement = height;
          this.isDisplacementNull = false
        }
      }
      else{
        this.displacement = 0;
        this.isDisplacementNull = true
      }

    }
    return result
  }


  private static AdjustNormals(line: THREE.Vector3[], sectionNormal: THREE.Vector3): THREE.Vector3[] {

    const segments = GeometryExtrusionComputer.CreateSegments(line);
    const normals: THREE.Vector3[] = [];
    for(let i = 0; i < line.length-1; i++){
      const segment = segments[i].map(p => p.clone());
      
      // double dotAbs = System.Math.Abs(Vector3D.Dot(segment.Direction, segment.Normal));

      // if (dotAbs > float.Epsilon && dotAbs < 1 - float.Epsilon)
      // {
      //   Vector3D z = segment.Normal * segment.Direction;
      //   Vector3D n = segment.Direction * z;
      //   n = Vector3D.Projection(segment.Normal, n);
      //   n.Normalize();
      //   this.SetNormal(i, n);
      // }
      let direction = (segment[1].clone().sub(segment[0].clone())).normalize();
      let dotAbs = Math.abs(direction.dot(sectionNormal.clone()));

      // if(dotAbs > 0.000001 && dotAbs < 0.999999){
      //   let z = sectionNormal.clone().multiply(direction);
      //   let n = direction.clone().multiply(z);
      //   n = n.projectOnVector(sectionNormal);
      //   n.normalize();
      //   normals.push(n);
      // }
      // else
      {
        normals.push(sectionNormal.clone());
        // normals.push(new THREE.Vector3(0,1,0));
      }
    }
    return normals;
  }

  // private static CreateSegments(line: THREE.Vector3[]){
  //   const segments: THREE.Vector3[][] = [];

  // }

 /**
   * Splits a polyline into straight segments.
   * @param line An array of points representing a (possibly zig-zag) polyline.
   * @returns An array of sub-arrays, each containing a maximal run of collinear points.
   */
  private static CreateSegments2(line: THREE.Vector3[]): THREE.Vector3[][] {
    const segments: THREE.Vector3[][] = [];

    const n = line.length;
    if (n === 0) return segments;
    if (n <= 2) {
      // A single point or just two points is trivially one “straight” segment
      return [ line.slice() ];
    }

    // small tolerance for “straightness”
    const epsilon = 1e-6;

    // start first segment with the first two points
    let current: THREE.Vector3[] = [ line[0].clone(), line[1].clone() ];

    for (let i = 2; i < n; i++) {
      const A = line[i - 2], B = line[i - 1], C = line[i];

      // v1 = B − A, v2 = C − B
      const v1 = new THREE.Vector3().subVectors(B, A);
      const v2 = new THREE.Vector3().subVectors(C, B);

      // collinearity test: cross(v1, v2) ≈ 0
      const cross = new THREE.Vector3().crossVectors(v1, v2);
      if (cross.length() <= epsilon * v1.length() * v2.length()) {
        // still straight: extend current segment
        current.push(C.clone());
      } else {
        // direction changed: close off the old segment...
        segments.push(current);
        // ...and start a new one from the last point of the old plus the current
        current = [ B.clone(), C.clone() ];
      }
    }

    // push the final segment
    segments.push(current);

    return segments;
  }

    /**
   * Splits a polyline into 2-point segments.
   * e.g. [P1,P2,P3,P4] → [[P1,P2],[P2,P3],[P3,P4]]
   */
    private static CreateSegments(line: THREE.Vector3[]): THREE.Vector3[][] {
      const segments: THREE.Vector3[][] = [];
      const n = line.length;
      if (n < 2) return segments;
  
      for (let i = 1; i < n; i++) {
        // make a small copy if you need to modify segments independently:
        segments.push([ line[i - 1].clone(), line[i].clone() ]);
        // or, if you don’t need clones, you could do:
        // segments.push([ line[i - 1], line[i] ]);
      }
  
      return segments;
    }

  private static generateFlange(
    webPoints: THREE.Vector3[],
    flangePoints: THREE.Vector3[],
    flangeIndices: number[],
    flangeAxisPoints: THREE.Vector3[],
    flangeWidthDirection: THREE.Vector3,
    condition: string,
    flangePosition: boolean,
    flangeWidth: number,
  ): void {
    switch (flangePosition) {
      case true:
        flangePoints.push(
          webPoints[2].clone().sub(flangeWidthDirection.clone().multiplyScalar(flangeWidth)),
          webPoints[3].clone().sub(flangeWidthDirection.clone().multiplyScalar(flangeWidth)),
          webPoints[4].clone().sub(flangeWidthDirection.clone().multiplyScalar(flangeWidth)),
          webPoints[2],
          webPoints[3],
          webPoints[4]
        );
        break;
      // case "middle":
      //   flangePoints.push(
      //     webPoints[2].clone().sub(flangeWidthDirection.clone().multiplyScalar(0.5 * flangeWidth)),
      //     webPoints[3].clone().sub(flangeWidthDirection.clone().multiplyScalar(0.5 * flangeWidth)),
      //     webPoints[4].clone().sub(flangeWidthDirection.clone().multiplyScalar(0.5 * flangeWidth)),
      //     webPoints[2].clone().add(flangeWidthDirection.clone().multiplyScalar(0.5 * flangeWidth)),
      //     webPoints[3].clone().add(flangeWidthDirection.clone().multiplyScalar(0.5 * flangeWidth)),
      //     webPoints[4].clone().add(flangeWidthDirection.clone().multiplyScalar(0.5 * flangeWidth))
      //   );
      //   break;
      case false:
        flangePoints.push(
          webPoints[2],
          webPoints[3],
          webPoints[4],
          webPoints[2].clone().add(flangeWidthDirection.clone().multiplyScalar(flangeWidth)),
          webPoints[3].clone().add(flangeWidthDirection.clone().multiplyScalar(flangeWidth)),
          webPoints[4].clone().add(flangeWidthDirection.clone().multiplyScalar(flangeWidth))
        );
        break;
    }
  
    flangeIndices.push(3, 0, 1, 3, 1, 4, 4, 1, 2, 4, 2, 5);
  
    flangeAxisPoints.push(
      flangePoints[0].clone().add(flangePoints[3]).multiplyScalar(0.5),
      flangePoints[1].clone().add(flangePoints[4]).multiplyScalar(0.5),
      flangePoints[2].clone().add(flangePoints[5]).multiplyScalar(0.5)
    );
  }
  

    private static getFaceNormalAtPoint(
        elementGeometry: THREE.Mesh,
        point: THREE.Vector3,
        plates: THREE.Mesh[],
        direction: THREE.Vector3
      ): THREE.Vector3 | null {
        // Make a small offset so the ray doesn't start *inside* the geometry
        // (which can cause zero-distance intersections).
        const origin = point.clone()//.addScaledVector(direction, 11.1);
      
        // const raycaster = new THREE.Raycaster(origin, direction.clone().normalize());


        const raycaster = new THREE.Raycaster(
          origin, direction.clone().normalize(),
        )
        raycaster.tolerance = 0.0
        raycaster.params = {
          Mesh: { threshold: 100 },
          Line: { threshold: 0.1 },
          LOD: {},
          Points: { threshold: 100 },
          Sprite: {},
        }
        const intersections = raycaster.intersectObjects(plates, true);
      
        if (intersections.length > 0) {
          // Take the closest intersection
          const intersection = intersections[0];
      
          // 'intersection.face.normal' is in local space of the geometry,
          // so clone it and transform it to world space:
          const worldNormal = intersection.face.normal.clone();
          worldNormal.transformDirection(intersection.object.matrixWorld);
          worldNormal.normalize();
      
          return worldNormal;
        }
        else{
          
          for (const plate of plates) {
            if (this.boxesDistance(plate.geometry.boundingBox, elementGeometry.geometry.boundingBox) <= 0.5) {// &&
              // if (plate.geometry.boundingBox.intersectsBox(stiffener.geometry.boundingBox)) {
              let  worldNormal = this.checkPointTriangleCollision(plate, point, 0.021);
              if(worldNormal !== null){
                worldNormal.normalize();
                return worldNormal;
              }
            }
          }
          
        }
      
        return null;
      }

    private static midpoint(p1: THREE.Vector3, p2: THREE.Vector3): THREE.Vector3 {
      return new THREE.Vector3(0.5 * (p1.x + p2.x),
      0.5 * (p1.y + p2.y),
      0.5 * (p1.z + p2.z),)
    }

    static getPlaneFromMesh(stiffenerMesh: THREE.Mesh): {
      normal: THREE.Vector3;
      pointOnPlane: THREE.Vector3;
    } | null {
      const geometry = stiffenerMesh.geometry as THREE.BufferGeometry;
    
      // We need position + index
      const posAttr = geometry.attributes.position;
      const idxAttr = geometry.index;
    
      if (!posAttr || !idxAttr || idxAttr.count < 3) {
        return null;
      }
    
      // Grab the first 3 indices from the geometry (which form one triangle)
      const iA = idxAttr.getX(0);
      const iB = idxAttr.getX(1);
      const iC = idxAttr.getX(2);
    
      // Vertex A in local space
      const A = new THREE.Vector3(
        posAttr.getX(iA),
        posAttr.getY(iA),
        posAttr.getZ(iA)
      );
      // Vertex B
      const B = new THREE.Vector3(
        posAttr.getX(iB),
        posAttr.getY(iB),
        posAttr.getZ(iB)
      );
      // Vertex C
      const C = new THREE.Vector3(
        posAttr.getX(iC),
        posAttr.getY(iC),
        posAttr.getZ(iC)
      );
    
      // Transform them to world space
      A.applyMatrix4(stiffenerMesh.matrixWorld);
      B.applyMatrix4(stiffenerMesh.matrixWorld);
      C.applyMatrix4(stiffenerMesh.matrixWorld);
    
      // Compute plane normal = cross((B - A), (C - A)) -> normalized
      const AB = new THREE.Vector3().subVectors(B, A);
      const AC = new THREE.Vector3().subVectors(C, A);
      const normal = AB.cross(AC).normalize();
    
      // 'A' is a point on the plane
      return { normal, pointOnPlane: A };
    }

    static distancePointToPlane(
      planePt: THREE.Vector3,
      planeNormal: THREE.Vector3,
      point: THREE.Vector3
    ): number {
      const v = new THREE.Vector3().subVectors(point, planePt);
      return Math.abs(v.dot(planeNormal));
    }

    static findConcurrentStiffener(
      stiffenerMeshes: THREE.Mesh[],
      lineStart: THREE.Vector3,
      lineEnd: THREE.Vector3,
      distanceTolerance: number = 1e-2,
      angleTolerance: number = 1e-3
    ) : THREE.Mesh | null {
    
      // 1) Direction of the line
      const lineDir = new THREE.Vector3().subVectors(lineEnd, lineStart).normalize();
    
      // We'll find the first stiffener that matches concurrency
      for (const mesh of stiffenerMeshes) {
        // 2) Get the plane info
        const plane = this.getPlaneFromMesh(mesh);
        if (!plane) continue;
    
        const { normal, pointOnPlane } = plane;
        
        // 3) Check if line is parallel (lineDir dot planeNormal ~ 0)
        const dotVal = lineDir.dot(normal); 
        if (Math.abs(dotVal) > angleTolerance) {
          // then the line is not in-plane; skip
          continue;
        }
    
        // 4) Check distance from any point on the line to plane
        const dist = this.distancePointToPlane(pointOnPlane, normal, lineStart);
        if (dist <= distanceTolerance) {
          // It's concurrent enough for our definition
          return mesh;
        }
      }
    
      return null; // If we never found one
    }

    public static getStiffenerHeight(
      stiffenerMesh: THREE.Mesh,
      planeNormal: THREE.Vector3  // <-- assumed local-space normal
    ): number {
      // 1) ensure the mesh’s world matrix is up to date
      stiffenerMesh.updateWorldMatrix(true, false);
    
      // 2) convert your local normal to world-space
      const worldDir = planeNormal
        .clone()
        .transformDirection(stiffenerMesh.matrixWorld)  // rotates & scales correctly
        .normalize();
    
      // 3) grab the geometry’s position attribute & the mesh’s world matrix
      const posAttr = (stiffenerMesh.geometry as THREE.BufferGeometry).getAttribute('position') as THREE.BufferAttribute;
      const worldMat = stiffenerMesh.matrixWorld;
    
      // 4) walk every vertex, project onto worldDir, track min/max
      const v = new THREE.Vector3();
      let minDot =  Infinity;
      let maxDot = -Infinity;
    
      for (let i = 0; i < posAttr.count; i++) {
        v.fromBufferAttribute(posAttr, i) // local vertex
         .applyMatrix4(worldMat);         // → world vertex
    
        const d = v.dot(worldDir);
        minDot = Math.min(minDot, d);
        maxDot = Math.max(maxDot, d);
      }
    
      // 5) difference is the true height along your plane’s normal
      return maxDot - minDot;
    }
    

    static isStiffenerOnPositiveSide(
      stiffenerMesh: THREE.Mesh,
      sectionPoint: THREE.Vector3,
      sectionNormal: THREE.Vector3
    ): boolean {
      // 1) Get bounding box in world space and its center
      const box = new THREE.Box3().setFromObject(stiffenerMesh);
      const center = box.getCenter(new THREE.Vector3());
    
      // 2) Vector from plane point -> stiffener center
      const v = new THREE.Vector3().subVectors(center, sectionPoint);
    
      // 3) Dot product with the plane normal
      const dotVal = v.dot(sectionNormal);
    
      // 4) Return true if stiffener is on the positive side of the plane
      //    (dotVal > 0 -> in the direction of the normal)
      return dotVal > 0;
    }

    static getNonIndexedPositionArray(points, indices ): number[] {
      // Clone arrays to avoid mutating the original data
      const stringWeb = JSON.parse(JSON.stringify(points)) as number[];
      const stringWebIndices = JSON.parse(JSON.stringify(indices)) as number[];
    
      // Create an indexed BufferGeometry
      const geometryweb = new THREE.BufferGeometry();
      const positionAttributeWeb = new THREE.Float32BufferAttribute(stringWeb, 3);
      geometryweb.setAttribute('position', positionAttributeWeb);
      geometryweb.setIndex(stringWebIndices);
    
      // Optionally compute normals and bounding box
      geometryweb.computeVertexNormals();
      geometryweb.computeBoundingBox();
    
      // Convert to non-indexed geometry
      const nonIndexedGeoWeb = geometryweb.toNonIndexed();
    
      // Access the position attribute array (Float32Array) and convert it to number[]
      const float32Array = nonIndexedGeoWeb.getAttribute('position').array as Float32Array;
      return Array.from(float32Array);
    }

    private static boxesDistance(box1: THREE.Box3, box2: THREE.Box3): number {
        return Math.min(...[box1.distanceToPoint(new THREE.Vector3(box2.min.x, box2.max.y, box2.max.z)),
        box1.distanceToPoint(new THREE.Vector3(box2.max.x, box2.min.y, box2.min.z)),
        box1.distanceToPoint(new THREE.Vector3(box2.min.x, box2.max.y, box2.min.z)),
        box1.distanceToPoint(new THREE.Vector3(box2.min.x, box2.min.y, box2.max.z)),
        box1.distanceToPoint(new THREE.Vector3(box2.max.x, box2.min.y, box2.max.z)),
        box1.distanceToPoint(new THREE.Vector3(box2.max.x, box2.max.y, box2.min.z)),
        box1.distanceToPoint(box2.max), box1.distanceToPoint(box2.min)]);
    }


    private static checkTriangleCollision(structure1: any, structure2: any, tolerance: number):THREE.Vector3 {
        // const line: Array<THREE.Vector3> = new Array<THREE.Vector3>();
        let normal:THREE.Vector3 = new THREE.Vector3();
        // let lineIndexesList = [];
        // it's possible to have same point in different indexes of the position array,
        // need to delete duplicates
        // const filteredIndexesList = this.removeDuplicatedPoints(structure2.geometry.index.array, structure2.geometry.attributes.position.array);

        for (let i = 0; i < structure1.geometry.index.array.length; i += 3) {
            const vA = new THREE.Vector3(structure1.geometry.attributes.position.array[structure1.geometry.index.array[i] * 3],
                structure1.geometry.attributes.position.array[structure1.geometry.index.array[i] * 3 + 1],
                structure1.geometry.attributes.position.array[structure1.geometry.index.array[i] * 3 + 2]);

            const vB = new THREE.Vector3(structure1.geometry.attributes.position.array[structure1.geometry.index.array[i + 1] * 3],
                structure1.geometry.attributes.position.array[structure1.geometry.index.array[i + 1] * 3 + 1],
                structure1.geometry.attributes.position.array[structure1.geometry.index.array[i + 1] * 3 + 2]);

            const vC = new THREE.Vector3(structure1.geometry.attributes.position.array[structure1.geometry.index.array[i + 2] * 3],
                structure1.geometry.attributes.position.array[structure1.geometry.index.array[i + 2] * 3 + 1],
                structure1.geometry.attributes.position.array[structure1.geometry.index.array[i + 2] * 3 + 2]);

            const tri = new THREE.Triangle(vA, vB, vC);
            if (tri.getArea() === 0) {
                continue;
            }

            for (let j = 0; j < structure2.geometry.index.array.length; j++) {
                const jR = structure2.geometry.index.array[j];
                const vst = new THREE.Vector3(structure2.geometry.attributes.position.array[jR * 3],
                    structure2.geometry.attributes.position.array[jR * 3 + 1],
                    structure2.geometry.attributes.position.array[jR * 3 + 2]);
                let closestPoint = new THREE.Vector3();
                tri.closestPointToPoint(vst, closestPoint);
                if (closestPoint.distanceTo(vst) <= tolerance) {
                   tri.getNormal(normal);
                   return normal;
                    // return true;
                }
            }
        }
        return null;
        // return [line, lineIndexesList, filteredIndexesList];
        // return [line, lineIndexesList];
    }

    private static checkPointTriangleCollision(structure1: any, point: any, tolerance: number):THREE.Vector3 {
      // const line: Array<THREE.Vector3> = new Array<THREE.Vector3>();
      let normal:THREE.Vector3 = new THREE.Vector3();
      // let lineIndexesList = [];
      // it's possible to have same point in different indexes of the position array,
      // need to delete duplicates
      // const filteredIndexesList = this.removeDuplicatedPoints(structure2.geometry.index.array, structure2.geometry.attributes.position.array);

      for (let i = 0; i < structure1.geometry.index.array.length; i += 3) {
          const vA = new THREE.Vector3(structure1.geometry.attributes.position.array[structure1.geometry.index.array[i] * 3],
              structure1.geometry.attributes.position.array[structure1.geometry.index.array[i] * 3 + 1],
              structure1.geometry.attributes.position.array[structure1.geometry.index.array[i] * 3 + 2]);

          const vB = new THREE.Vector3(structure1.geometry.attributes.position.array[structure1.geometry.index.array[i + 1] * 3],
              structure1.geometry.attributes.position.array[structure1.geometry.index.array[i + 1] * 3 + 1],
              structure1.geometry.attributes.position.array[structure1.geometry.index.array[i + 1] * 3 + 2]);

          const vC = new THREE.Vector3(structure1.geometry.attributes.position.array[structure1.geometry.index.array[i + 2] * 3],
              structure1.geometry.attributes.position.array[structure1.geometry.index.array[i + 2] * 3 + 1],
              structure1.geometry.attributes.position.array[structure1.geometry.index.array[i + 2] * 3 + 2]);

          const tri = new THREE.Triangle(vA, vB, vC);
          if (tri.getArea() === 0) {
              continue;
          }

          const vst = point;
          let closestPoint = new THREE.Vector3();
          tri.closestPointToPoint(vst, closestPoint);
          if (closestPoint.distanceTo(vst) <= tolerance) {
              tri.getNormal(normal);
              return normal.normalize();
              // return true;
          }
      }
      return null;
      // return [line, lineIndexesList, filteredIndexesList];
      // return [line, lineIndexesList];
  }
  static cutMeshWithPlane(
    elementMesh: THREE.Mesh,
    perpendicularPlane: THREE.Plane
  ): { positiveGeometry: THREE.BufferGeometry; negativeGeometry: THREE.BufferGeometry } | null {
    const geometry = elementMesh.geometry as THREE.BufferGeometry;
    const positionAttr = geometry.attributes.position;
    const indexAttr = geometry.index;
    if (!indexAttr) {
      console.error('Geometry must be indexed');
      return null;
    }
  
    // A small epsilon for numerical robustness.
    const EPS = 1e-6;
  
    // Arrays to accumulate vertices and indices for the two resulting meshes.
    const posVertices: number[] = [];
    const posIndices: number[] = [];
    const negVertices: number[] = [];
    const negIndices: number[] = [];
  
    // Global array to store intersection points (for the cap).
    const capIntersections: THREE.Vector3[] = [];
  
    // --- Helper Functions ---
  
    // Determines whether a vertex is "inside" the halfspace.
    // For positive halfspace, we treat vertices with distance >= -EPS as inside.
    // For negative, we use distance <= EPS.
    function isInside(vertex: THREE.Vector3, keepPositive: boolean): boolean {
      const d = perpendicularPlane.distanceToPoint(vertex);
      return keepPositive ? (d >= -EPS) : (d <= EPS);
    }
  
    // Computes the intersection point between the line (p1 to p2) and the plane.
    function computeIntersection(p1: THREE.Vector3, p2: THREE.Vector3): THREE.Vector3 {
      const d1 = perpendicularPlane.distanceToPoint(p1);
      const d2 = perpendicularPlane.distanceToPoint(p2);
      const t = d1 / (d1 - d2);
      return new THREE.Vector3().lerpVectors(p1, p2, t);
    }
  
    // Sutherland–Hodgman polygon clipping.
    // Takes an input polygon (array of THREE.Vector3) and clips it to the halfspace defined by keepPositive.
    // Also stores any computed intersection point in capIntersections.
    function clipPolygon(polygon: THREE.Vector3[], keepPositive: boolean): THREE.Vector3[] {
      const clipped: THREE.Vector3[] = [];
      // Loop over the polygon edges.
      for (let i = 0; i < polygon.length; i++) {
        const curr = polygon[i];
        const prev = polygon[(i - 1 + polygon.length) % polygon.length];
        const currInside = isInside(curr, keepPositive);
        const prevInside = isInside(prev, keepPositive);
        // When an edge crosses the plane, compute the intersection.
        if (prevInside !== currInside) {
          const intersectPt = computeIntersection(prev, curr);
          clipped.push(intersectPt);
          // Store the intersection for use in capping.
          capIntersections.push(intersectPt);
        }
        if (currInside) {
          clipped.push(curr);
        }
      }
      return clipped;
    }
  
    // Fan triangulate a polygon (assumed convex or at least simple).
    // Returns an array of triangle indices (as offsets relative to baseIndex)
    function fanTriangulate(nVerts: number, baseIndex: number, indicesArray: number[]) {
      for (let i = 1; i < nVerts - 1; i++) {
        indicesArray.push(baseIndex, baseIndex + i, baseIndex + i + 1);
      }
    }
  
    // Remove duplicates from an array of THREE.Vector3.
    // Two points are considered equal if their coordinates match within EPS.
    function uniquePoints(points: THREE.Vector3[]): THREE.Vector3[] {
      const unique: THREE.Vector3[] = [];
      for (const p of points) {
        if (!unique.some(q => Math.abs(p.x - q.x) < EPS && Math.abs(p.y - q.y) < EPS && Math.abs(p.z - q.z) < EPS)) {
          unique.push(p);
        }
      }
      return unique;
    }
  
    // Compute a convex hull in 2D using the Graham scan.
    // Returns the indices (in order) of the hull vertices.
    function convexHull2D(points: THREE.Vector2[]): number[] {
      if (points.length <= 3) {
        return points.map((_, i) => i);
      }
      // Find the point with the lowest y (and then x) coordinate.
      let minIndex = 0;
      for (let i = 1; i < points.length; i++) {
        if (points[i].y < points[minIndex].y || 
           (Math.abs(points[i].y - points[minIndex].y) < EPS && points[i].x < points[minIndex].x)) {
          minIndex = i;
        }
      }
      const pivot = points[minIndex];
      // Sort the points by polar angle with pivot.
      const sorted = points.map((pt, i) => ({ pt, i }))
        .sort((a, b) => {
          if (a.i === minIndex) return -1;
          if (b.i === minIndex) return 1;
          const angleA = Math.atan2(a.pt.y - pivot.y, a.pt.x - pivot.x);
          const angleB = Math.atan2(b.pt.y - pivot.y, b.pt.x - pivot.x);
          return angleA - angleB;
        });
      // Graham scan.
      const hull: number[] = [];
      for (const { pt, i } of sorted) {
        while (hull.length >= 2) {
          const last = points[hull[hull.length - 1]];
          const secondLast = points[hull[hull.length - 2]];
          // Compute the cross product (as scalar) for orientation.
          const cross = (last.x - secondLast.x) * (pt.y - secondLast.y) - (last.y - secondLast.y) * (pt.x - secondLast.x);
          if (cross < EPS) {
            hull.pop();
          } else {
            break;
          }
        }
        hull.push(i);
      }
      return hull;
    }
  
    // --- Main Processing Loop ---
    // Iterate over each triangle in the mesh.
    for (let i = 0; i < indexAttr.count; i += 3) {
      const i1 = indexAttr.getX(i);
      const i2 = indexAttr.getX(i + 1);
      const i3 = indexAttr.getX(i + 2);
  
      // Get triangle vertices in world space.
      const v1 = new THREE.Vector3(
        positionAttr.getX(i1),
        positionAttr.getY(i1),
        positionAttr.getZ(i1)
      ).applyMatrix4(elementMesh.matrixWorld);
      const v2 = new THREE.Vector3(
        positionAttr.getX(i2),
        positionAttr.getY(i2),
        positionAttr.getZ(i2)
      ).applyMatrix4(elementMesh.matrixWorld);
      const v3 = new THREE.Vector3(
        positionAttr.getX(i3),
        positionAttr.getY(i3),
        positionAttr.getZ(i3)
      ).applyMatrix4(elementMesh.matrixWorld);
      const triangle: THREE.Vector3[] = [v1, v2, v3];
  
      // Clip triangle against the plane for the positive halfspace.
      const clippedPos = clipPolygon(triangle, true);
      if (clippedPos.length >= 3) {
        const baseIndex = posVertices.length / 3;
        for (const p of clippedPos) {
          posVertices.push(p.x, p.y, p.z);
        }
        fanTriangulate(clippedPos.length, baseIndex, posIndices);
      }
  
      // Clip triangle against the plane for the negative halfspace.
      const clippedNeg = clipPolygon(triangle, false);
      if (clippedNeg.length >= 3) {
        const baseIndex = negVertices.length / 3;
        for (const p of clippedNeg) {
          negVertices.push(p.x, p.y, p.z);
        }
        fanTriangulate(clippedNeg.length, baseIndex, negIndices);
      }
    } // end for-each triangle
  
    // --- Cap Generation ---
    // Remove duplicate intersection points.
    const uniqueCapPoints = uniquePoints(capIntersections);
    if (uniqueCapPoints.length >= 3) {
      // Build a local 2D coordinate frame for the cutting plane.
      const planeNormal = perpendicularPlane.normal.clone();
      let tangent = new THREE.Vector3();
      if (Math.abs(planeNormal.x) > 0.9) tangent.set(0, 1, 0);
      else tangent.set(1, 0, 0);
      const bitangent = new THREE.Vector3().crossVectors(planeNormal, tangent).normalize();
      tangent = new THREE.Vector3().crossVectors(bitangent, planeNormal).normalize();
  
      // Project the cap points into 2D.
      const cap2D: { point: THREE.Vector2; original: THREE.Vector3 }[] = uniqueCapPoints.map(pt => {
        return {
          point: new THREE.Vector2(pt.dot(tangent), pt.dot(bitangent)),
          original: pt
        };
      });
      // Compute convex hull of the 2D points.
      const pts2D = cap2D.map(item => item.point);
      const hullIndices = convexHull2D(pts2D);
      // Construct the ordered cap polygon in 3D.
      const capPolygon: THREE.Vector3[] = hullIndices.map(i => cap2D[i].original);
  
      // Fan-triangulate the cap polygon and add to both sides.
      // Positive side: use as-is.
      const posCapBase = posVertices.length / 3;
      for (const p of capPolygon) {
        posVertices.push(p.x, p.y, p.z);
      }
      fanTriangulate(capPolygon.length, posCapBase, posIndices);
      // Negative side: reverse winding.
      const negCapBase = negVertices.length / 3;
      for (const p of capPolygon) {
        negVertices.push(p.x, p.y, p.z);
      }
      for (let i = 1; i < capPolygon.length - 1; i++) {
        negIndices.push(negCapBase, negCapBase + i + 1, negCapBase + i);
      }
    }
  
    // --- Build BufferGeometries ---
    const positiveGeometry = new THREE.BufferGeometry();
    positiveGeometry.setAttribute('position', new THREE.Float32BufferAttribute(posVertices, 3));
    positiveGeometry.setIndex(posIndices);
    positiveGeometry.computeVertexNormals();
  
    const negativeGeometry = new THREE.BufferGeometry();
    negativeGeometry.setAttribute('position', new THREE.Float32BufferAttribute(negVertices, 3));
    negativeGeometry.setIndex(negIndices);
    negativeGeometry.computeVertexNormals();
  
    return { positiveGeometry, negativeGeometry };
  }
}
interface TriangleRaycastResult {
  mesh: THREE.Mesh;
  distance: number;
  point: THREE.Vector3;
  triangleIndex: number;
}

interface HeightProfile {
  linePoint: THREE.Vector3;
  closestPoint: THREE.Vector3;
  surfaceNormal: THREE.Vector3;
  meshHeight: number;
}

class MeshHeightAnalyzer {
  private worldTriangles: THREE.Triangle[];
  private worldVertices: THREE.Vector3[];
  private boundingBox: THREE.Box3;

  constructor(private mesh: THREE.Mesh) {
    this.processGeometry();
  }

  private processGeometry() {
    const geometry = this.mesh.geometry as THREE.BufferGeometry;
    const positionAttribute = geometry.attributes.position as any;
    this.worldTriangles = [];
    this.worldVertices = [];

    // Convert vertices to world space
    for (let i = 0; i < positionAttribute.count; i++) {
      const vertex = new THREE.Vector3()
        .fromBufferAttribute(positionAttribute, i)
        .applyMatrix4(this.mesh.matrixWorld);
      this.worldVertices.push(vertex);
    }

    // Create triangles in world space
    const index = geometry.index?.array || [];
    const nonIndexed = index.length === 0;
    const triangleCount = nonIndexed ? positionAttribute.count / 3 : index.length / 3;

    for (let i = 0; i < triangleCount; i++) {
      const a = nonIndexed ? i * 3 : index[i * 3];
      const b = nonIndexed ? i * 3 + 1 : index[i * 3 + 1];
      const c = nonIndexed ? i * 3 + 2 : index[i * 3 + 2];

      this.worldTriangles.push(new THREE.Triangle(
        this.worldVertices[a],
        this.worldVertices[b],
        this.worldVertices[c]
      ));
    }

    this.boundingBox = new THREE.Box3().setFromObject(this.mesh);
  }

  public getHeightProfile(linePoints: THREE.Vector3[]): HeightProfile[] {
    return linePoints.map(linePoint => {
      const { closestPoint, normal } = this.findClosestSurfaceData(linePoint);
      return {
        linePoint,
        closestPoint,
        surfaceNormal: normal,
        meshHeight: this.calculateHeightAlongNormal(normal)
      };
    });
  }

  private findClosestSurfaceData(point: THREE.Vector3): {
    closestPoint: THREE.Vector3,
    normal: THREE.Vector3
  } {
    if (!this.boundingBox.containsPoint(point)) {
      return { closestPoint: point.clone(), normal: new THREE.Vector3() };
    }

    let minDistance = Infinity;
    let closestPoint = new THREE.Vector3();
    let closestNormal = new THREE.Vector3();

    for (const triangle of this.worldTriangles) {
      const tempPoint = new THREE.Vector3();
      triangle.closestPointToPoint(point, tempPoint);
      const distance = point.distanceToSquared(tempPoint);

      if (distance < minDistance) {
        minDistance = distance;
        closestPoint.copy(tempPoint);
        triangle.getNormal(closestNormal);
      }
    }

    return { closestPoint, normal: closestNormal.normalize() };
  }

  private calculateHeightAlongNormal(normal: THREE.Vector3): number {
    const projections = this.worldVertices.map(v => v.dot(normal));
    return Math.max(...projections) - Math.min(...projections);
  }
}
